var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfilePortfolio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.995 511.995",
    style: {
      enableBackground: "new 0 0 511.995 511.995"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#006775"
    },
    cx: 255.997,
    cy: 255.997,
    r: 255.997
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#055661"
    },
    d: "M293.428,509.223l-175.147-178.7l284.987-173.924l108.509,108.509 c-4.443,124.502-97.735,226.346-218.349,244.005L293.428,509.223L293.428,509.223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA45"
    },
    d: "M123.724,141.938h260.331c9.108,0,16.548,7.442,16.548,16.548v153.488 c0,9.108-7.442,16.548-16.548,16.548h-39.316l-29.099,36.428l-29.099-36.428H123.724c-9.108,0-16.548-7.442-16.548-16.548V158.487 C107.176,149.38,114.617,141.938,123.724,141.938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00CC96"
    },
    d: "M159.708,245.338h1.999l11.883-6.442l1.888-7.553c-2.777-2.888-5.776-7.664-8.441-13.66 c-0.222,0-0.444,0-0.666,0c-3.11,0-6.22-3.443-6.886-7.664c-0.555-3.332,0.555-6.109,2.555-7.219 c-2.666-13.549-4.443-34.318,18.881-39.427c13.994-3.11,18.992,7.664,19.547,8.885c8.441-4.776,13.883,2.332,15.215,6.109 c2.555,6.775,1.666,19.436,0.444,25.1c1.444,1.333,2.11,3.776,1.666,6.553c-0.666,4.11-3.665,7.553-6.775,7.664 c-2.444,5.442-5.887,10.107-9.219,13.549l1.888,7.553h0.111l11.55,6.442h2.221c15.215,0,27.655,11.994,27.655,26.544v21.546H131.943 v-21.546c0-14.66,12.439-26.544,27.655-26.544L159.708,245.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M258.11,180.255h111.841v10.439H258.11V180.255z M258.11,242.783h55.975v10.439H258.11V242.783z  M258.11,221.904h111.841v10.439H258.11V221.904z M258.11,201.024h111.841v10.439H258.11V201.024z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePortfolio);
export default __webpack_public_path__ + "static/media/profile-portfolio.26cb47e97d80882eb661c3943aa6c2a4.svg";
export { ForwardRef as ReactComponent };